import template from './talajtipus-terkep.pug';
import popupTemplate from './talajtipus-terkep-popup.pug';
import 'ngmap';
const MODULE_NAME = 'talajtipusTerkep';
let self; // googlemap bindel a metódusainak nagy részére (pl getMap) ezért nem lehet elérni a controller scopeot máshogyan
let scope;

class TalajtipusTerkepController {
	constructor($scope, $timeout, NgMap, $uibModal, environment, $q) {
		'ngInject';
		self = this;
		scope = $scope;
		this._q = $q;
		this.$timeout = $timeout;
		this.NgMap = NgMap;
		this.$uibModal = $uibModal;
		this.talaj = '';
		this.environment = environment;
		this.src = this.environment.talajTipusKmlLayer;
		this.talajTipusok = {
			1: {nev: 'Csernozjom talaj'},
			2: {nev: 'Barna erdőtalaj'},
			3: {nev: 'Réti talaj'},
			4: {nev: 'Homok talaj'}
		};
	}

	$onInit() {
		this.NgMap.getMap().then(function (map) {
			self.map = map;
			let kmlLayer = new window.google.maps.KmlLayer({
				url: self.src,
				suppressInfoWindows: true,
				map: map,
				preserveViewport: true
			});
			kmlLayer.addListener('click', function (kmlEvent) {
				self.clickOnLayer(kmlEvent);
				if (!scope.$$phase) {
					scope.$apply();
				}
			});
		}, () => {
			return this._$q.reject();
		});
	}

	clickOnLayer(kmlEvent) {
		let regexpPattern = /<td>GRIDCODE<\/td>(\n\n)<td>(.+?)/g;
		let match = regexpPattern.exec(kmlEvent.featureData.description);
		if (match && match[2] && isFinite(match[2]) && match[2] > 0 && match[2] < 5) {
			self.talaj = self.talajTipusok[match[2]].nev;
		}
	}

	clickOkButton() {
		this.setTalajTipus({nev: this.talaj});
		this.modalPopup.close();
	}

	openModal() {
		if (this.selectedTalaj) {
			this.talaj = this.selectedTalaj;
		} else {
			this.talaj = '';
		}

		this.modalPopup = this.$uibModal.open({
			animation: false,
			backdrop: false,
			scope: scope,
			template: popupTemplate()
		});
		this.NgMap.getMap().then(function (map) {
			window.google.maps.event.trigger(map, 'resize');
		}, () => {
			return this._$q.reject();
		});
	}
}

export default angular.module(MODULE_NAME, ['ngMap'])
	.component(MODULE_NAME, {
		controller: TalajtipusTerkepController,
		template: template(),
		bindings: {
			setTalajTipus: '&',
			selectedTalaj: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/gazdalkodasikalkulator/talajtipus-terkep/talajtipus-terkep.js